module.exports = __webpack_public_path__ + "static/img/son2.fdb1747c.png";